import React, { CSSProperties, PropsWithChildren } from 'react';
import classnames from 'classnames';

import * as styles from './styles.module.less';

interface ISubTitleProps {
  type?: 'primary' | 'secondary';
  className?: string;
  style?: CSSProperties;
}

const SubTitle: React.FC<PropsWithChildren<ISubTitleProps>> = ({ type = 'primary', children, className, style }) => {
  const PrimarySubtitle = styles.subtitle_primary;
  const SecondarySubtitle = styles.subtitle_secondary;
  const subTitleClassName = type === 'secondary' ? SecondarySubtitle : PrimarySubtitle;
  return (
    <span className={classnames(subTitleClassName, className)} style={style}>
      {children}
    </span>
  );
};

export default SubTitle;
